import { Component, OnInit, OnDestroy, ElementRef, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, Validators } from '@angular/forms';
import pageSettings from '../../../config/page-settings';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import * as $ from 'jquery';
import { BaseService } from '../../../services/base.services';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'init',
  templateUrl: './init.html',
  styleUrls: ['init.css']
})

export class InitPage implements OnInit, OnDestroy {
  bg;
  bgList;
  app;
  pageSettings = pageSettings;
  loginForm: any;
  isLoading: boolean = false;
  error;
  country = 'chile';
  rut;
  carnet = '';
  divisionSeleccionada = 'DSAL';
  sitioSeleccionado = 1;
  listDivisiones:any = [];
  CaptchaDiv;
  txtCaptcha;
  CaptchaInput;
  imgCaptcha;
  mostrarClave = false;
  password;
  @ViewChild('messageError',  {static: false}) messageError: any;
  constructor(
      private router: Router,
      private formBuilder: FormBuilder,
      private baseServices: BaseService,
      private eleRef: ElementRef,
      private route: ActivatedRoute,
      private toastr: ToastrService,
    ) {
    this.pageSettings.pageEmpty = true;
    this.loginForm = this.formBuilder.group({
      Rut:  new FormControl('', [Validators.required])
    });
  }

  ngOnDestroy() {
    this.pageSettings.pageEmpty = false;
  }

  ngOnInit() {
    localStorage.removeItem('data');
    this.route.params.subscribe( params =>{
      if(params['pais']) {
        this.country = params['pais'];
      }
    });
    //this.get_Divisiones();

    this.resetCaptcha();
    this.new_Captcha();
  }

  resetCaptcha(){
    var a = Math.ceil(Math.random() * 9)+ '';
    var b = Math.ceil(Math.random() * 9)+ '';
    var c = Math.ceil(Math.random() * 9)+ '';
    var d = Math.ceil(Math.random() * 9)+ '';
    var e = Math.ceil(Math.random() * 9)+ '';
    
    var code = a + b + c + d + e;
    this.txtCaptcha = code;
    this.CaptchaDiv = code;
    //this.createCaptcha(code);
  }

   toBase64(arr) {
    //arr = new Uint8Array(arr) if it's an ArrayBuffer
    return btoa(
       arr.reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
   }

  async get_Divisiones(){
    try{
      var _storage = JSON.parse( localStorage.getItem('data'));  
      var response = await this.baseServices.get_Divisiones({idDivision: 0}).toPromise();
      this.listDivisiones =  response;
      this.divisionSeleccionada = this.listDivisiones[0].Sigla;

    }catch(error){
      console.log(error);
    }    
  }

  async new_Captcha(){
    try{
      var response:any = await this.baseServices.new_Captcha().toPromise();
      var data = this.toBase64(response.message.data)
      this.imgCaptcha = 'data:image/png;base64,' + data;
    }catch(error){
      console.log(error);
    }    
  }



  formatedRut(rut: any, $event: any) {
    if (rut) {
      return this.formatRut(rut, $event);
    } else {
      return null;
    }
  }

  formatRut (texto: any, event: any) {
    if (
      event &&
      event.type != 'blur' &&
      event.code != 'Enter' &&
      event.code != '13' &&
      event.code != 13 &&
      event.charCode != '13' &&
      event.charCode != 13
    )
      return texto;

    if (texto === null || texto === undefined) return null;
    var size = texto.length;
    if (size == 1) return texto;

    //console.log('Antes: ' + texto);
    //si tiene puntos (.) o guiones (-) se los saca
    texto = (texto.slice(0, size - 1).replace(/[^\d]/gi, '') + texto.slice(size - 1).replace(/[^\d^k]/gi, '')).replace(
      /^[0]*/g,
      ''
    );
    //console.log('Después: ' + texto);

    var number = texto.substring(0, texto.length - 1);
    var dv = texto.substring(texto.length - 1);
    //agrega los puntos (.) y el guión (-)
    var rut =
      number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function($1) {
        return $1 + '.';
      }) +
      '-' +
      dv;
    //console.log(rut);

    return rut;
  }


  async go(){
    try{
      /*var rut = this.formatRut(this.rut, null);
      var isValidRut = this.rutEsValido(this.rut);
      if(!isValidRut){
        return;
      }
      var Captcha = this.checkCaptcha();
      if(Captcha){
        return;
      }
      */

      if(!this.rut){
        this.toastr.error('Por favor, ingrese todos los campos', '¡Alerta!');
        return;
      }
      var body = {
        Division: 'DCH',
        Validador: this.rut,
        Captcha: this.CaptchaInput       
      }

      var response : any = await this.baseServices.sp_Login(body).toPromise();
      if(response.length > 0){
       if(response[0].Error){
          this.CaptchaInput = '';
          this.toastr.error(response[0].Error, 'Alerta');
          this.new_Captcha();
          return;
        }
      }  

      localStorage.setItem('data', JSON.stringify({
        Division: 'DCH', 
        Validador: body.Validador, 
        usuario: response[0]
      }));      

      this.router.navigate(['/ingresos'], { replaceUrl: true });
    }catch(error){
      console.log(error);
    }
  }

   rutEsValido(rut) {
    if (!rut || rut.trim().length < 3) return false;
    rut = rut.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '');
    const rutLimpio = rut.replace(/[^0-9kK-]/g, "");
  
    if (rutLimpio.length < 3) return false;
  
    const split = rutLimpio.split("-");
    if (split.length !== 2) return false;
  
    const num = parseInt(split[0], 10);
    const dgv = split[1];
  
    const dvCalc = this.calculateDV(num);
    return dvCalc === dgv;
  }
  
   calculateDV(rut) {
    const cuerpo: any = `${rut}`;
    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;
  
    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      const index = multiplo * cuerpo.charAt(cuerpo.length - i);
  
      // Sumar al Contador General
      suma += index;
  
      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo += 1;
      } else {
        multiplo = 2;
      }
    }
  
    // Calcular Dígito Verificador en base al Módulo 11
    const dvEsperado = 11 - (suma % 11);
    if (dvEsperado === 10) return "k";
    if (dvEsperado === 11) return "0";
    return `${dvEsperado}`;
  }
  
  
  checkCaptcha(){
    var why = "";
    
    if(this.CaptchaInput == ""){
      why += "Por favor, escriba el codigo.\n";
    }

    if(this.CaptchaInput != ""){
      if(this.ValidCaptcha() == false){
        why += "El numero no coincide con el captcha.\n";

      }
    }
    if(why != ""){
      this.toastr.error(why, '¡Alerta!');
      this.resetCaptcha();
      return true;
    }
    return false;
  }
        
    ValidCaptcha(){
      var str1 = this.txtCaptcha;
      var str2 = this.CaptchaInput;
      if (str1 == str2){
       return true;
      }else{
        return false;
      }
    }
    
    // Remove the spaces from the entered and generated code
    removeSpaces(string){
      return string.split(' ').join('');
    }


    createCaptcha(codigo) {
      var canv: any = null
      canv = document.getElementById('captcha');
      if (canv.getContext) {
        canv.id = "captcha";
        canv.width = 70;
        canv.height = 40;
        var ctx =null;
        var ctx = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.beginPath();
        var width = 70;
        var height = 40;
        
        //context.fillRect(0, 0, width, height);
        for(var i=0; i < 4; i+=1) {
          ctx.beginPath();
          ctx.moveTo(Math.random() * width, Math.random() * height);
          ctx.lineTo(Math.random() * width, Math.random() * height);
          ctx.stroke();
        }
        
        ctx.strokeText(codigo, 0, 30);

      }
    }
    
}
